export const buildDownloadFile = (fileName: string, type: string): any => {
  return ((response: any) => {
    const url = window.URL.createObjectURL(
      new Blob([response.data], {
        type,
      }),
    );
    const link = document.createElement('a');

    link.href = url;
    link.setAttribute(
      'download',
      fileName,
    );
    document.body.appendChild(link);
    link.click();
  });
};
